// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    GENERAL: {
      PROGRESS: 'Progress',
      TEAM: 'Team',
      SORT_BY: 'Sort By',
      FILTER_BY: 'Filter By',
      IMPACT_LEVEL: 'Impact Level',
      QUICK_TOOLS: 'Quick Tools',
      QUICK_LINKS: 'Quick Links',
      COMPLETED: 'Completed',
      IN_PROGRESS: 'In Progress',
      SEARCH: 'Search...',
      RECENTLY_SEARCHED: 'Recently Searched',
      NO_RESULT_FOUND: 'No result found',
      NO_RESULT_FOUND_DESC: 'Please try again with a different query',
      ADVANCED_SEARCH: 'Advanced Search',
      SEARCH_PREFERENCES: 'Search Preferences',
      TODAY_BUTTON: 'Today',
      WEEK_BUTTON: 'Week',
      DAY_BUTTON: 'Day',
      FILTER_BUTTON: 'Filter',
      CREATE_BUTTON: 'Create',
      VIEW_BUTTON: 'View',
      CANCEL_BUTTON: 'Cancel',
      SEARCH_BUTTON: 'Search',
      SAVE_CHANGES_BUTTON: 'Save Changes',
      LOADING_DATE_RANGE: 'Loading date range...',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      LAYOUT_BUILDER: 'Layout Builder',
      CRAFTED: 'Crafted',
      ACCOUNTS: 'Accounts',
      OVERVIEW: 'Overview',
      SETTINGS: 'Settings',
      ERRORS: 'Errors',
      ERROR_404: 'Error 404',
      ERROR_500: 'Error 500',
      PASCAL: 'Pascal',
      COMPANY: 'Donstudio',
      ABOUT: 'About',
      SUPPORT: 'Support',
      DOCUMENTS: 'documents',
      ACTIVITY_LOGS: 'Activity Logs',
      MY_PROFILE: 'My Profile',
      MY_PROJECTS: 'My Projects',
      MY_SUBSCRIPTION: 'My Subscription',
      REFERRALS: 'Referrals',
      BILLING: 'Billing',
      PAYMENTS: 'Payments',
      STATEMENTS: 'Statements',
      NOTIFICATIONS: 'Notifications',
      MY_STATEMENTS: 'My Statements',
      LANGUAGE: 'Language',
      ACCOUNT_SETTINGS: 'Account Settings',
      SIGN_OUT: 'Sign Out',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don\'t have an account?',
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username'
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields'
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    },
    AG_GRID_COLUMNS: {
      ROW_NUMBER: 'Row number',
      CREATE_DATE: 'Create date',
      REFER: 'Refer',
      DESCRIPTION: 'Description',
      DEBIT: 'Debit',
      CREDIT: 'Credit',
      REMAIN_DEBIT: 'Remain debit',
      REMAIN_CREDIT: 'Remain credit',
    },
    AG_GRID_LOCALE: {
      // Set Filter
      SELECT_ALL: '(Select All)',
      SELECT_ALL_SEARCH_RESULTS: '(Select All Search Results)',
      SEARCH_OOO: 'Search...',
      BLANKS: '(Blanks)',
      NO_MATCHES: 'No matches',

      // Number Filter & Text Filter
      FILTER_OOO: 'Filter...',
      EQUALS: 'Equals',
      NOT_EQUAL: 'Not equal',
      BLANK: 'Blank',
      NOT_BLANK: 'Not blank',
      EMPTY: 'Choose One',

      // Number Filter
      LESS_THAN: 'Less than',
      GREATER_THAN: 'Greater than',
      LESS_THAN_OR_EQUAL: 'Less than or equal',
      GREATER_THAN_OR_EQUAL: 'Greater than or equal',
      IN_RANGE: 'In range',
      IN_RANGE_START: 'from',
      IN_RANGE_END: 'to',

      // Text Filter
      CONTAINS: 'Contains',
      NOT_CONTAINS: 'Not contains',
      STARTS_WITH: 'Starts with',
      ENDS_WITH: 'Ends with',

      // Date Filter
      DATE_FORMAT_OOO: 'yyyy-mm-dd',

      // Filter Conditions
      AND_CONDITION: 'AND',
      OR_CONDITION: 'OR',

      // Filter Buttons
      APPLY_FILTER: 'Apply',
      RESET_FILTER: 'Reset',
      CLEAR_FILTER: 'Clear',
      CANCEL_FILTER: 'Cancel',

      // Filter Titles
      TEXT_FILTER: 'Text Filter',
      NUMBER_FILTER: 'Number Filter',
      DATE_FILTER: 'Date Filter',
      SET_FILTER: 'Set Filter',

      // Group Column Filter
      GROUP_FILTER_SELECT: 'Select field:',

      // Advanced Filter
      ADVANCED_FILTER_CONTAINS: 'contains',
      ADVANCED_FILTER_NOT_CONTAINS: 'does not contain',
      ADVANCED_FILTER_TEXT_EQUALS: 'equals',
      ADVANCED_FILTER_TEXT_NOT_EQUAL: 'does not equal',
      ADVANCED_FILTER_STARTS_WITH: 'starts with',
      ADVANCED_FILTER_ENDS_WITH: 'ends with',
      ADVANCED_FILTER_BLANK: 'is blank',
      ADVANCED_FILTER_NOT_BLANK: 'is not blank',
      ADVANCED_FILTER_EQUALS: '=',
      ADVANCED_FILTER_NOT_EQUAL: '!=',
      ADVANCED_FILTER_GREATER_THAN: '>',
      ADVANCED_FILTER_GREATER_THAN_OR_EQUAL: '>=',
      ADVANCED_FILTER_LESS_THAN: '<',
      ADVANCED_FILTER_LESS_THAN_OR_EQUAL: '<=',
      ADVANCED_FILTER_TRUE: 'is true',
      ADVANCED_FILTER_FALSE: 'is false',
      ADVANCED_FILTER_AND: 'AND',
      ADVANCED_FILTER_OR: 'OR',
      ADVANCED_FILTER_APPLY: 'Apply',
      ADVANCED_FILTER_VALIDATION_MISSING_COLUMN: 'Column is missing',
      ADVANCED_FILTER_VALIDATION_MISSING_OPTION: 'Option is missing',
      ADVANCED_FILTER_VALIDATION_MISSING_VALUE: 'Value is missing',
      ADVANCED_FILTER_VALIDATION_INVALID_COLUMN: 'Column not found',
      ADVANCED_FILTER_VALIDATION_INVALID_OPTION: 'Option not found',
      ADVANCED_FILTER_VALIDATION_MISSING_QUOTE: 'Value is missing an end quote',
      ADVANCED_FILTER_VALIDATION_NOT_A_NUMBER: 'Value is not a number',
      ADVANCED_FILTER_VALIDATION_MISSING_CONDITION: 'Condition is missing',
      ADVANCED_FILTER_VALIDATION_JOIN_OPERATOR_MISMATCH: 'Join operators within a condition must be the same',
      ADVANCED_FILTER_VALIDATION_INVALID_JOIN_OPERATOR: 'Join operator not found',
      ADVANCED_FILTER_VALIDATION_MISSING_END_BRACKET: 'Missing end bracket',
      ADVANCED_FILTER_VALIDATION_EXTRA_END_BRACKET: 'Too many end brackets',
      ADVANCED_FILTER_VALIDATION_MESSAGE: 'Expression has an error. ${VARIABLE1} - ${VARIABLE2}.',
      ADVANCED_FILTER_VALIDATION_MESSAGE_AT_END: 'Expression has an error. ${VARIABLE} at end of expression.',

      // Side Bar
      COLUMNS: 'Columns',
      FILTERS: 'Filters',

      // columns tool panel
      PIVOT_MODE: 'Pivot Mode',
      GROUPS: 'Row Groups',
      ROW_GROUP_COLUMNS_EMPTY_MESSAGE: 'Drag here to set row groups',
      VALUES: 'Values',
      VALUE_COLUMNS_EMPTY_MESSAGE: 'Drag here to aggregate',
      PIVOTS: 'Column Labels',
      PIVOT_COLUMNS_EMPTY_MESSAGE: 'Drag here to set column labels',

      // Header of the Default Group Column
      GROUP: 'Group',

      // Row Drag
      ROW_DRAG_ROW: 'row',
      ROW_DRAG_ROWS: 'rows',

      // Other
      LOADING_OOO: 'Loading...',
      LOADING_ERROR: 'ERR',
      NO_ROWS_TO_SHOW: 'No Rows To Show',
      ENABLED: 'Enabled',

      // Menu
      PIN_COLUMN: 'Pin Column',
      PIN_LEFT: 'Pin Left',
      PIN_RIGHT: 'Pin Right',
      NO_PIN: 'No Pin',
      VALUE_AGGREGATION: 'Value Aggregation',
      NO_AGGREGATION: 'None',
      AUTOSIZE_THIS_COLUMN: 'Autosize This Column',
      AUTOSIZE_ALL_COLUMNS: 'Autosize All Columns',
      GROUP_BY: 'Group by',
      UNGROUP_BY: 'Un-Group by',
      UNGROUP_ALL: 'Un-Group All',
      ADD_TO_VALUES: 'Add ${VARIABLE} to values',
      REMOVE_FROM_VALUES: 'Remove ${VARIABLE} from values',
      ADD_TO_LABELS: 'Add ${VARIABLE} to labels',
      REMOVE_FROM_LABELS: 'Remove ${VARIABLE} from labels',
      RESET_COLUMNS: 'Reset Columns',
      EXPAND_ALL: 'Expand All Row Groups',
      COLLAPSE_ALL: 'Close All Row Groups',
      COPY: 'Copy',
      CTRL_C: 'Ctrl+C',
      CTRL_X: 'Ctrl+X',
      COPY_WITH_HEADERS: 'Copy With Headers',
      COPY_WITH_GROUP_HEADERS: 'Copy with Group Headers',
      CUT: 'Cut',
      PASTE: 'Paste',
      CTRL_V: 'Ctrl+V',
      EXPORT: 'Export',
      CSV_EXPORT: 'CSV Export',
      EXCEL_EXPORT: 'Excel Export',

      // Enterprise Menu Aggregation and Status Bar
      SUM: 'Sum',
      FIRST: 'First',
      LAST: 'Last',
      MIN: 'Min',
      MAX: 'Max',
      NONE: 'None',
      COUNT: 'Count',
      AVG: 'Average',
      FILTERED_ROWS: 'Filtered',
      SELECTED_ROWS: 'Selected',
      TOTAL_ROWS: 'Total Rows',
      TOTAL_AND_FILTERED_ROWS: 'Rows',
      MORE: 'More',
      TO: 'to',
      OF: 'of',
      PAGE: 'Page',
      PAGE_LAST_ROW_UNKNOWN: '?',
      NEXT_PAGE: 'Next Page',
      LAST_PAGE: 'Last Page',
      FIRST_PAGE: 'First Page',
      PREVIOUS_PAGE: 'Previous Page',

      // Pivoting
      PIVOT_COLUMN_GROUP_TOTALS: 'Total',

      // Enterprise Menu (Charts)
      PIVOT_CHART_AND_PIVOT_MODE: 'Pivot Chart & Pivot Mode',
      PIVOT_CHART: 'Pivot Chart',
      CHART_RANGE: 'Chart Range',

      COLUMN_CHART: 'Column',
      GROUPED_COLUMN: 'Grouped',
      STACKED_COLUMN: 'Stacked',
      NORMALIZED_COLUMN: '100% Stacked',

      BAR_CHART: 'Bar',
      GROUPED_BAR: 'Grouped',
      STACKED_BAR: 'Stacked',
      NORMALIZED_BAR: '100% Stacked',

      PIE_CHART: 'Pie',
      PIE: 'Pie',
      DOUGHNUT: 'Doughnut',

      LINE: 'Line',

      XY_CHART: 'X Y (Scatter)',
      SCATTER: 'Scatter',
      BUBBLE: 'Bubble',

      AREA_CHART: 'Area',
      AREA: 'Area',
      STACKED_AREA: 'Stacked',
      NORMALIZED_AREA: '100% Stacked',

      HISTOGRAM_CHART: 'Histogram',
      HISTOGRAM_FREQUENCY: "Frequency",

      COMBINATION_CHART: 'Combination',
      COLUMN_LINE_COMBO: 'Column & Line',
      AREA_COLUMN_COMBO: 'Area & Column',

      // Charts
      PIVOT_CHART_TITLE: 'Pivot Chart',
      RANGE_CHART_TITLE: 'Range Chart',
      SETTINGS: 'Settings',
      DATA: 'Data',
      FORMAT: 'Format',
      CATEGORIES: 'Categories',
      DEFAULT_CATEGORY: '(None)',
      SERIES: 'Series',
      XY_VALUES: 'X Y Values',
      PAIRED: 'Paired Mode',
      AXIS: 'Axis',
      NAVIGATOR: 'Navigator',
      COLOR: 'Color',
      THICKNESS: 'Thickness',
      X_TYPE: 'X Type',
      AUTOMATIC: 'Automatic',
      CATEGORY: 'Category',
      NUMBER: 'Number',
      TIME: 'Time',
      AUTO_ROTATE: 'Auto Rotate',
      X_ROTATION: 'X Rotation',
      Y_ROTATION: 'Y Rotation',
      TICKS: 'Ticks',
      WIDTH: 'Width',
      HEIGHT: 'Height',
      LENGTH: 'Length',
      PADDING: 'Padding',
      SPACING: 'Spacing',
      CHART: 'Chart',
      TITLE: 'Title',
      TITLE_PLACEHOLDER: 'Chart title - double click to edit',
      BACKGROUND: 'Background',
      FONT: 'Font',
      TOP: 'Top',
      RIGHT: 'Right',
      BOTTOM: 'Bottom',
      LEFT: 'Left',
      LABELS: 'Labels',
      SIZE: 'Size',
      MIN_SIZE: 'Minimum Size',
      MAX_SIZE: 'Maximum Size',
      LEGEND: 'Legend',
      POSITION: 'Position',
      MARKER_SIZE: 'Marker Size',
      MARKER_STROKE: 'Marker Stroke',
      MARKER_PADDING: 'Marker Padding',
      ITEM_SPACING: 'Item Spacing',
      ITEM_PADDING_X: 'Item Padding X',
      ITEM_PADDING_Y: 'Item Padding Y',
      LAYOUT_HORIZONTAL_SPACING: 'Horizontal Spacing',
      LAYOUT_VERTICAL_SPACING: 'Vertical Spacing',
      STROKE_WIDTH: 'Stroke Width',
      LINE_DASH: 'Line Dash',
      OFFSET: 'Offset',
      OFFSETS: 'Offsets',
      TOOLTIPS: 'Tooltips',
      CALLOUT: 'Callout',
      MARKERS: 'Markers',
      SHADOW: 'Shadow',
      BLUR: 'Blur',
      X_OFFSET: 'X Offset',
      Y_OFFSET: 'Y Offset',
      LINE_WIDTH: 'Line Width',
      NORMAL: 'Normal',
      BOLD: 'Bold',
      ITALIC: 'Italic',
      BOLD_ITALIC: 'Bold Italic',
      PREDEFINED: 'Predefined',
      FILL_OPACITY: 'Fill Opacity',
      STROKE_OPACITY: 'Line Opacity',
      HISTOGRAM_BIN_COUNT: 'Bin count',
      COLUMN_GROUP: 'Column',
      BAR_GROUP: 'Bar',
      PIE_GROUP: 'Pie',
      LINE_GROUP: 'Line',
      SCATTER_GROUP: 'X Y (Scatter)',
      AREA_GROUP: 'Area',
      HISTOGRAM_GROUP: 'Histogram',
      COMBINATION_GROUP: 'Combination',
      GROUPED_COLUMN_TOOLTIP: 'Grouped',
      STACKED_COLUMN_TOOLTIP: 'Stacked',
      NORMALIZED_COLUMN_TOOLTIP: '100% Stacked',
      GROUPED_BAR_TOOLTIP: 'Grouped',
      STACKED_BAR_TOOLTIP: 'Stacked',
      NORMALIZED_BAR_TOOLTIP: '100% Stacked',
      PIE_TOOLTIP: 'Pie',
      DOUGHNUT_TOOLTIP: 'Doughnut',
      LINE_TOOLTIP: 'Line',
      GROUPED_AREA_TOOLTIP: 'Area',
      STACKED_AREA_TOOLTIP: 'Stacked',
      NORMALIZED_AREA_TOOLTIP: '100% Stacked',
      SCATTER_TOOLTIP: 'Scatter',
      BUBBLE_TOOLTIP: 'Bubble',
      HISTOGRAM_TOOLTIP: 'Histogram',
      COLUMN_LINE_COMBO_TOOLTIP: 'Column & Line',
      AREA_COLUMN_COMBO_TOOLTIP: 'Area & Column',
      CUSTOM_COMBO_TOOLTIP: 'Custom Combination',
      NO_DATA_TO_CHART: 'No data available to be charted.',
      PIVOT_CHART_REQUIRES_PIVOT_MODE: 'Pivot Chart requires Pivot Mode enabled.',
      CHART_SETTINGS_TOOLBAR_TOOLTIP: 'Menu',
      CHART_LINK_TOOLBAR_TOOLTIP: 'Linked to Grid',
      CHART_UNLINK_TOOLBAR_TOOLTIP: 'Unlinked from Grid',
      CHART_DOWNLOAD_TOOLBAR_TOOLTIP: 'Download Chart',
      SERIES_CHART_TYPE: 'Series Chart Type',
      SERIES_TYPE: 'Series Type',
      SECONDARY_AXIS: 'Secondary Axis',

      // ARIA
      ARIA_ADVANCED_FILTER_INPUT: 'Advanced Filter Input',
      ARIA_CHECKED: 'checked',
      ARIA_COLUMN: 'Column',
      ARIA_COLUMN_GROUP: 'Column Group',
      ARIA_COLUMN_LIST: 'Column List',
      ARIA_COLUMN_SELECT_ALL: 'Toggle Select All Columns',
      ARIA_DATE_FILTER_INPUT: 'Date Filter Input',
      ARIA_DEFAULT_LIST_NAME: 'List',
      ARIA_FILTER_COLUMNS_INPUT: 'Filter Columns Input',
      ARIA_FILTER_FROM_VALUE: 'Filter from value',
      ARIA_FILTER_INPUT: 'Filter Input',
      ARIA_FILTER_LIST: 'Filter List',
      ARIA_FILTER_TO_VALUE: 'Filter to value',
      ARIA_FILTER_VALUE: 'Filter Value',
      ARIA_FILTER_MENU_OPEN: 'Open Filter Menu',
      ARIA_FILTERING_OPERATOR: 'Filtering Operator',
      ARIA_HIDDEN: 'hidden',
      ARIA_INDETERMINATE: 'indeterminate',
      ARIA_INPUT_EDITOR: 'Input Editor',
      ARIA_MENU_COLUMN: 'Press CTRL ENTER to open column menu.',
      ARIA_ROW_DESELECT: 'Press SPACE to deselect this row',
      ARIA_ROW_SELECT_ALL: 'Press Space to toggle all rows selection',
      ARIA_ROW_TOGGLE_SELECTION: 'Press Space to toggle row selection',
      ARIA_ROW_SELECT: 'Press SPACE to select this row',
      ARIA_SEARCH: 'Search',
      ARIA_SORTABLE_COLUMN: 'Press ENTER to sort',
      ARIA_TOGGLE_VISIBILITY: 'Press SPACE to toggle visibility',
      ARIA_TOGGLE_CELL_VALUE: 'Press SPACE to toggle cell value',
      ARIA_UNCHECKED: 'unchecked',
      ARIA_VISIBLE: 'visible',
      ARIA_SEARCH_FILTER_VALUES: 'Search filter values',

      // ARIA Labels for Drop Zones
      ARIA_ROW_GROUP_DROP_ZONE_PANEL_LABEL: 'Row Groups',
      ARIA_VALUES_DROP_ZONE_PANEL_LABEL: 'Values',
      ARIA_PIVOT_DROP_ZONE_PANEL_LABEL: 'Column Labels',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_DESCRIPTION: 'Press DELETE to remove',
      ARIA_DROP_ZONE_COLUMN_VALUE_ITEM_DESCRIPTION: 'Press ENTER to change the aggregation type',
      ARIA_DROP_ZONE_COLUMN_GROUP_ITEM_DESCRIPTION: 'Press ENTER to sort',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_AGG_FUNC_SEPARATOR: ' of ',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_SORT_ASCENDING: 'ascending',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_SORT_DESCENDING: 'descending',

      // ARIA Labels for Dialogs
      ARIA_LABEL_COLUMN_MENU: 'Column Menu',
      ARIA_LABEL_CELL_EDITOR: 'Cell Editor',
      ARIA_LABEL_DIALOG: 'Dialog',
      ARIA_LABEL_SELECT_FIELD: 'Select Field',
      ARIA_LABEL_RICH_SELECT_FIELD: 'Rich Select Field',
      ARIA_LABEL_TOOLTIP: 'Tooltip',
      ARIA_LABEL_CONTEXT_MENU: 'Context Menu',
      ARIA_LABEL_SUB_MENU: 'SubMenu',
      ARIA_LABEL_AGGREGATION_FUNCTION: 'Aggregation Function',
      ARIA_LABEL_ADVANCED_FILTER_AUTOCOMPLETE: 'Advanced Filter Autocomplete',

      // Number Format (Status Bar, Pagination Panel)
      THOUSAND_SEPARATOR: ',',
      DECIMAL_SEPARATOR: '.',

      // Data types
      TRUE: 'True',
      FALSE: 'False',
      INVALID_DATE: 'Invalid Date',
      INVALID_NUMBER: 'Invalid Number',
      JANUARY: 'January',
      FEBRUARY: 'February',
      MARCH: 'March',
      APRIL: 'April',
      MAY: 'May',
      JUNE: 'June',
      JULY: 'July',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'October',
      NOVEMBER: 'November',
      DECEMBER: 'December',
    },
  },
};
